import React from 'react';
import { Navigate } from 'react-router-dom';

import { Paths } from '../../../shared/paths';
import { useAccess } from '../../../hooks/useAccess';
import { SyncInnerTabs } from './SyncInnerTabs';

export default function Sync() {
  const { access } = useAccess();
  const canViewSyncData =
    access?.syncRules?.canView ??
    access?.adminPanels?.canViewAdminPanel ??
    false;
  const canViewSyncRules = access?.syncRules?.canView ?? false;
  const canViewSyncSection = canViewSyncData || canViewSyncRules;

  if (!canViewSyncSection) {
    return <Navigate to={Paths.root} replace />;
  }

  return <SyncInnerTabs />;
}
